export const PURCHASE_STATUS = 'purchase';
export const SUCCESS_PURCHASE_STATUS = 'success purchase';
export const TIMEOUT_PURCHASE_STATUS = 'timeout';
